<template>
  <div>
    <div class="error-page">
        <h2 class="headline text-red">500</h2>

        <div class="error-content">
          <h3><i class="fa fa-warning text-red"></i> Oops! Algo deu errado.</h3>
          <p>
            Por favor, entre em contato conosco com uma descrição dos passos realizados por você que o levaram até este erro.
            <br>
            Trabalharemos para resolver o problema o mais rápido possível.
          </p>
          <p>
            Enquanto isto, você pode retornar à <router-link :to="{ name: 'Homepage' }" exact><a> <span>página inicial</span></a></router-link> e continuar
            a navegação.
          </p>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'ServerError'
}
</script>



// WEBPACK FOOTER //
// ServerError.vue?79b6cb8b